import { render, staticRenderFns } from "./Coverage360Tab.vue?vue&type=template&id=84016cda&scoped=true&"
import script from "./Coverage360Tab.vue?vue&type=script&lang=js&"
export * from "./Coverage360Tab.vue?vue&type=script&lang=js&"
import style0 from "./Coverage360Tab.vue?vue&type=style&index=0&id=84016cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84016cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
